import defaultAttributes from '../defaultAttributes';

const FileType = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z',
      },
    ],
    ['polyline', { points: '14 2 14 8 20 8' }],
    ['path', { d: 'M9 13v-1h6v1' }],
    ['path', { d: 'M11 18h2' }],
    ['path', { d: 'M12 12v6' }],
  ],
];

export default FileType;
